import { render } from "./revoke.vue?vue&type=template&id=527de183"
import script from "./revoke.vue?vue&type=script&lang=js"
export * from "./revoke.vue?vue&type=script&lang=js"

import exportComponent from "D:\\startup\\gtdhtml5\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__